import type { SVGProps } from 'react';
const SvgKeyboardTab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#keyboard_tab_svg__a)">
      <path
        fill="currentColor"
        d="M11.59 7.41 15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41ZM20 6v12h2V6h-2Z"
      />
    </g>
    <defs>
      <clipPath id="keyboard_tab_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKeyboardTab;
